import AuthorizeService from "../components/api-authorization/AuthorizeService";
import { Languaje } from "../models/Entities/Settings/Languajes";
import { jwtDecode } from "jwt-decode";

interface TokenInfo {
    language: string;
}


// REMOVE this when the API is ready
const auxLenguajes = new Array<Languaje>(
    {
        code: 'es',
        description: 'Español'
    },
    {
        code: 'en',
        description: 'English'
    },
    {
        code: 'pr',
        description: 'Português'
    }
) 

var LanguajesPromise = new Promise<Languaje[]>((resolve, reject) => {
    resolve(auxLenguajes);
});

/**
 * Idioma elegido explicitamente por el usuario. Vive en localStorage porque hoy
 * no hay servicio que lo persista del lado del servidor (ver SetUserLanguaje):
 * sin esto la eleccion se perdia en cada refresco y la pantalla volvia al claim
 * del token, o al español si el token no trae idioma.
 */
export const LANGUAGE_STORAGE_KEY = 'prebiller.language';

export const GetStoredLanguajeCode = (): string | undefined => {
    try {
        return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) || undefined;
    } catch {
        // Modo privado o storage bloqueado: se sigue sin preferencia guardada.
        return undefined;
    }
};

export const StoreLanguajeCode = (code: string | undefined): void => {
    try {
        if (code) {
            window.localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
        } else {
            window.localStorage.removeItem(LANGUAGE_STORAGE_KEY);
        }
    } catch {
        // Sin storage la eleccion vale para esta sesion y nada mas.
    }
};

function GetUserLanguaje (token: string) {
    return new Promise<string | undefined>((resolve) => {
        try {
            // El claim es opcional: un token sin `language` no es un error, solo
            // significa que el idioma lo decide la preferencia local.
            const decodedToken = jwtDecode<TokenInfo>(token);
            resolve(decodedToken?.language);
        } catch {
            resolve(undefined);
        }
    });
};


export const GetLanguajes = async (): Promise<Languaje[]> => {

    return LanguajesPromise.then((data: Languaje[]) => {
        return data;
    });

};

/**
 * Idioma con el que arranca la aplicacion, por orden de prioridad:
 *   1. lo que el usuario eligio (localStorage) — es una decision explicita
 *   2. el claim `language` del token
 *   3. español
 * Sincrono a proposito: i18next necesita el idioma inicial al inicializarse y
 * leer el token es asincrono. El paso 2 lo resuelve despues GetAllLanguajes.
 */
export const GetInitialLanguajeCode = (): string => GetStoredLanguajeCode() || 'es';

export const GetCurrentUserLanguaje = async (): Promise<Languaje | undefined> => {

    const languajes = await GetLanguajes();

    // La preferencia explicita gana sobre el token: si el usuario cambio el
    // idioma a mano, releer el claim en cada apertura del menu se lo pisaba.
    const storedCode = GetStoredLanguajeCode();
    const stored = storedCode ? languajes.find(x => x.code === storedCode) : undefined;
    if (stored) return stored;

    const token = await AuthorizeService.getAccessToken();
    if (!token) return undefined;

    const tokenCode = await GetUserLanguaje(token);
    return tokenCode ? languajes.find(x => x.code === tokenCode) : undefined;
}